// extracted by mini-css-extract-plugin
export default {"text-m":"Title_text-m__LnDJa","text-s":"Title_text-s__N8CNP","text-xs":"Title_text-xs__FBBVE","wrapper":"Title_wrapper__ecLnA"};